import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <footer class="bg-foreground text-background border-t border-border">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 py-12">
          <!-- Brand -->
          <div class="space-y-4">
            <div class="flex items-center gap-2">
              <div class="w-10 h-10 rounded-xl bg-primary flex items-center justify-center">
                <svg class="w-5 h-5 text-primary-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12h1m2 0h14M6 12a2 2 0 11-4 0 2 2 0 014 0zm12 0a2 2 0 11-4 0 2 2 0 014 0zM9 8h2m2 8h2"/></svg>
              </div>
              <div>
                <div class="text-lg font-bold">پارس فیتنس</div>
                <div class="text-xs opacity-60">PARAS FITNESS</div>
              </div>
            </div>
            <p class="text-sm opacity-70 leading-6">بهترین باشگاه ورزشی با بیش از ۱۵ سال تجربه در ارائه خدمات ورزشی حرفه‌ای.</p>
          </div>

          <!-- Quick Links -->
          <div class="space-y-4">
            <h3 class="font-bold">دسترسی سریع</h3>
            <ul class="space-y-2">
              <li *ngFor="let link of quickLinks">
                <a [routerLink]="link.link" class="text-sm opacity-70 hover:opacity-100 transition-opacity">{{ link.label }}</a>
              </li>
            </ul>
          </div>

          <!-- Popular Classes -->
          <div class="space-y-4">
            <h3 class="font-bold">دوره‌های محبوب</h3>
            <ul class="space-y-2">
              <li *ngFor="let cls of popularClasses">
                <a routerLink="/classes" class="text-sm opacity-70 hover:opacity-100 transition-opacity">{{ cls }}</a>
              </li>
            </ul>
          </div>

          <!-- Contact -->
          <div class="space-y-4">
            <h3 class="font-bold">اطلاعات تماس</h3>
            <div class="space-y-3 text-sm opacity-70">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                <span>تهران، خیابان ولیعصر</span>
              </div>
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
                <span>۰۲۱-۸۸۷۷۶۶۵۵</span>
              </div>
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                <span>info&#64;parsfitness.ir</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Bottom -->
        <div class="border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p class="text-xs opacity-60">&copy; ۱۴۰۵ باشگاه ورزشی پارس فیتنس. تمامی حقوق محفوظ است.</p>
          <button (click)="scrollToTop()" class="fixed bottom-6 left-6 z-40 bg-primary text-primary-foreground rounded-full w-12 h-12 shadow-lg hover:shadow-xl flex items-center justify-center">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"/></svg>
          </button>
        </div>
      </div>
    </footer>
  `,
  styles: [':host { display: block; }']
})
export class FooterComponent {
  quickLinks = [
    { label: 'صفحه اصلی', link: '/' },
    { label: 'درباره ما', link: '/about' },
    { label: 'دوره‌ها', link: '/classes' },
    { label: 'محصولات', link: '/products' },
    { label: 'گالری', link: '/gallery' },
    { label: 'مربیان', link: '/trainers' },
    { label: 'تماس با ما', link: '/contact' },
  ];

  popularClasses = [
    'بدنسازی حرفه‌ای',
    'یوگا و مدیتیشن',
    'آیروبیک و فیتنس',
    'هنرهای رزمی',
    'کراس‌فیت',
    'پیلاتس',
    'بوکس و کیک‌بوکسینگ',
  ];

  constructor() {}

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
